import _ from 'lodash'
import { APP_SETTINGS } from '@/common/config'
import axiosIns from '@/libs/axios'
import useJwt from '@/auth/jwt/useJwt'
import SystemHelper from '@/common/systemHelper'

export const GET_INTRODUCER_TRANSACTION_PAYOUT_RECORD = 'getIntroducerTransactionPayoutRecord'
export const SET_INTRODUCER_TRANSACTION_PAYOUT_RECORD = 'setIntroducerTransactionPayoutRecord'

export default {
  namespaced: true,
  state: {
    introducerTransactionPayoutRecord: null,
  },
  getters: {
    getRawData: state => key => {
      const data = state[key]
      if (data) {
        return data.list
      } return {}
    },
    getPaginationInfo: state => {
      const list = state.introducerTransactionPayoutRecord
      if (list) {
        return list
      }
      return []
    },
    getPayoutRecord: state => {
      const currentState = state.introducerTransactionPayoutRecord
      if (currentState) {
        const list = currentState.list.data
        if (Array.isArray(list) && list.length) {
          return list
        }
        return []
      }
      return []
    },
  },
  mutations: {
    [SET_INTRODUCER_TRANSACTION_PAYOUT_RECORD](state, val) {
      state.introducerTransactionPayoutRecord = val
    },
  },
  actions: {
    // account-introducer/introducer-record-data
    [GET_INTRODUCER_TRANSACTION_PAYOUT_RECORD](context, payload) {
      return new Promise((resolve, reject) => {
        /// account-introducer/introducer-payout-record-data
        const endpoint = `account-introducer/introducer-payout-record-data?skip=${payload.skip}&limit=${payload.limit}`

        axiosIns.post(`${APP_SETTINGS.BASE_URL + APP_SETTINGS.API_VERSION_NUM}${endpoint}`, payload)
          .then(res => {
            if (res.data.response_code === 2000) {
              useJwt.setToken(res.data.token)

              context.commit(SET_INTRODUCER_TRANSACTION_PAYOUT_RECORD, res.data.data)

              SystemHelper.successHandler(res)
              resolve(res)
            } else {
              SystemHelper.errorHandler(res)
              resolve(res)
            }
          })
          .catch(err => {
            SystemHelper.handleCatch()
            reject(err)
          })
      })
    },
  },
}
